import { CountryIntelligenceRulesAdditionalSalariesSalaries, Employment } from "@oysterhr/schema"
import useAdditionalSalariesInfo from "../VariableCompensationSection/hooks/useAdditionalSalariesInfo"

const isIncludedInMonthlyCalculation = (
  salaryRule?: Pick<
    CountryIntelligenceRulesAdditionalSalariesSalaries,
    | "isPartOfGrossSalary"
    | "isDefaultEnabled"
    | "canBeProrated"
    | "arePaymentMonthsEditable"
    | "defaultSelectedMonths"
    | "maxSelectedMonths"
  >,
) => {
  if (!salaryRule) return false
  const {
    isPartOfGrossSalary,
    isDefaultEnabled,
    canBeProrated,
    arePaymentMonthsEditable,
    defaultSelectedMonths,
    maxSelectedMonths,
  } = salaryRule
  return (
    isPartOfGrossSalary &&
    isDefaultEnabled &&
    !canBeProrated &&
    ((!arePaymentMonthsEditable && defaultSelectedMonths?.length === 1) ||
      (arePaymentMonthsEditable && maxSelectedMonths === 1))
  )
}

/**
 * Defines in how many salaries the gross annual salary should be divided,
 * taking into consideration the 13th/14th salary in applicable countries.
 */
export const useSalaryPaymentsNum = (countryCode: Employment["countryCode"]) => {
  const { additionalSalariesRules } = useAdditionalSalariesInfo({
    countryCode: countryCode || "",
  })

  let defaultPaymentsNum = 12
  if (!additionalSalariesRules) return defaultPaymentsNum

  if (isIncludedInMonthlyCalculation(additionalSalariesRules.salary13th)) {
    defaultPaymentsNum += 1
  }
  if (isIncludedInMonthlyCalculation(additionalSalariesRules.salary14th)) {
    defaultPaymentsNum += 1
  }
  return defaultPaymentsNum
}
